<div class="main-content p-0 shadow-none">
  <section id="overview">
      <!-- // Retailers data block -->
      <div class="row justify-content-end">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <mat-card class="shadow mb-3">
            <div class="top-retailers">
              <div class="chart-holder">
                <div class="report-overview-blk">
                  <ul class="list-inline ">
                    <li class="list-inline-item">
                      <h4 class="overview-title" translate>pages.newRetailer.overview</h4>
                    </li>
                    <li class="list-inline-item">
                      <mat-form-field appearance="outline">
                        <mat-select
                          [(value)]="selectedTopRetailersRange"
                          (selectionChange)="
                            onSelectRetailerDateRange($event.value)
                          "
                        >
                          <mat-option
                            *ngFor="let range of dateRange"
                            [value]="range.days"
                          >
                          {{range.value}}<span translate> {{range.translatetitle}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </li>
                  </ul>
                </div>
                  <div  echarts [options]="topRetailersChartOption" class="echart-retailer chart-item"></div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <!-- // Products data block -->
      <div class="row justify-content-start" *ngIf="displaygraph">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <mat-card class="shadow my-3">
            <div class="top-products">
              <div class="chart-holder">
                <div class="report-overview-blk">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <h4 class="overview-title" translate>pages.newRetailer.overview</h4>
                    </li>
                    <li class="list-inline-item">
                      <mat-form-field appearance="outline">
                        <mat-select
                          [(value)]="selectedTopProductsRange"
                          (selectionChange)="
                            onSelectProductsDateRange($event.value)
                          "
                        >
                          <mat-option
                            *ngFor="let range of dateRange"
                            [value]="range.days"
                          >
                          {{range.value}}<span translate> {{range.translatetitle}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </li>
                  </ul>
                </div>
                  <div echarts [options]="topProductsChartOption" class="echart-products chart-item" ></div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <!-- // State data block --> 
      <div class="row " *ngIf="displaygraph">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <mat-card class="shadow my-3">
            <div class="top-states">
              <!-- <div class="row">
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                  <div class="details-holder">
                    <div class="report-details">
                      <h4 class="report-title" translate>
                        pages.newRetailer.top20stateswithmaximumsales
                      </h4>
                      <div class="report-desc">
                        
                      </div>
                    </div>
                    <ul class="list-inline">
                      <li class="list-inline-item">
                        <div class="reports-top-list">
                          <h4 class="top-list-tilte" translate>pages.newRetailer.totalSales</h4>
                          <p class="top-list-count">{{totalSales | currency}}</p>
                        </div>
                      </li>
                      <li class="list-inline-item">
                        <div class="reports-top-list">
                          <h4 class="top-list-tilte" translate>pages.newRetailer.totalOrder</h4>
                          <p class="top-list-count">{{totalSalesCount}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                  
                </div>
              </div> -->
              <div class="chart-holder">
                <div class="report-overview-blk">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <h4 class="overview-title" translate>pages.newRetailer.overview</h4>
                    </li>
                    <li class="list-inline-item">
                      <mat-form-field appearance="outline">
                        <mat-select
                          [(value)]="selectedTopStatesRange"
                          (selectionChange)="
                            onSelectStatesDateRange($event.value)
                          "
                        >
                          <mat-option
                            *ngFor="let range of dateRange"
                            [value]="range.days"
                          >
                          {{range.value}}<span translate> {{range.translatetitle}}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </li>
                  </ul>
                </div>
                  <div echarts  [options]="topStatesChartOption" class="echart-retailer chart-item"></div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
  </section>
</div>
